import backend, {LOOM_API} from 'utils/backend/loom/api_library';

const loomApi = () => {
  if (!LOOM_API) {
    throw new Error('REACT_APP_LOOM_API must be configured before Loom client jobs can be enabled.');
  }

  return LOOM_API.replace(/\/$/, '');
};

const clientJobsPath = (clientId) => {
  return `${loomApi()}/api/careos/clients/${encodeURIComponent(clientId)}/jobs`;
};

const listClientJobs = (clientId) => {
  return backend.get(clientJobsPath(clientId));
};

const generateJob = (clientId, body) => {
  return backend.post(`${clientJobsPath(clientId)}/generate`, body);
};

const updateJob = (jobId, body) => {
  return backend.post(`${loomApi()}/api/careos/jobs/${encodeURIComponent(jobId)}/update`, body);
};

const updateJobStatus = (jobId, body) => {
  return backend.post(`${loomApi()}/api/careos/jobs/${encodeURIComponent(jobId)}/status/update`, body);
};

const listCandidates = (jobId, radiusKm) => {
  return backend.get(`${loomApi()}/api/careos/jobs/${encodeURIComponent(jobId)}/candidates?radiusKm=${radiusKm}`);
};

const sendInvitation = (jobId, caregiverId) => {
  return backend.post(`${loomApi()}/api/careos/jobs/${encodeURIComponent(jobId)}/invitation`, {caregiverId});
};

const listInvitations = (jobId) => {
  return backend.get(`${loomApi()}/api/careos/jobs/${encodeURIComponent(jobId)}/invitations`);
};

const cancelInvitation = (invitationId) => {
  return backend.post(`${loomApi()}/api/careos/invitations/${encodeURIComponent(invitationId)}/cancel`);
};

const listInterviewQuestions = (jobId) => {
  return backend.get(`${loomApi()}/api/careos/jobs/${encodeURIComponent(jobId)}/interview-questions`);
};

const updateInterviewQuestions = (jobId, questions) => {
  return backend.post(`${loomApi()}/api/careos/jobs/${encodeURIComponent(jobId)}/interview-questions/update`, {questions});
};

export default {
  listClientJobs,
  generateJob,
  updateJob,
  updateJobStatus,
  listCandidates,
  sendInvitation,
  listInvitations,
  cancelInvitation,
  listInterviewQuestions,
  updateInterviewQuestions,
};
